<template>
  <div>
    <v-toolbar dense flat>
      <v-subheader>{{$t('solutions')}}</v-subheader>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-expansion-panels style="z-index: unset" v-model="active" v-if="markerXSolutions.length > 0">
      <v-expansion-panel
        lazy
        v-for="(markerXSolution,i) in markerXSolutions"
        :key="i"
        :ref="'section-'+i"
      >
        <v-expansion-panel-header>
          <div class="subheading">{{markerXSolution.solution.name}}</div>
          <template v-slot:actions>
            <v-icon
              :color="markerXSolution.isApproved === 1 && !markerXSolution.valid ? 'red' :
                     markerXSolution.isApproved === 0 && !markerXSolution.valid ? 'orange':
                      markerXSolution.isApproved === 2? 'success': 'primary'"
            >{{markerXSolution.isApproved === 2 ? 'check_circle' : markerXSolution.isApproved === 1 ? 'priority_high': 'priority_high'}}</v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content style="display: block !important">
          <div class="active-row">
            <v-divider></v-divider>
            <v-list-item two-line>
              <v-list-item-title
                style="overflow: wrap"
                class="headline"
              >{{markerXSolution.solution.name}}</v-list-item-title>
              <v-list-item-avatar tile size="125">
                <v-img
                  aspect-ratio="1"
                  :src="markerXSolution.product ? markerXSolution.product : emptyImage"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-divider></v-divider>
            <v-list subheader three-line>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t("details") }}</v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-list-item-subtitle v-on="on" v-html="attributesToString(markerXSolution)"></v-list-item-subtitle>
                    </template>
                    <span v-html="attributesToString(markerXSolution)"></span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ $t("dimensions") }}</v-list-item-title>
                  <v-tooltip bottom>
                    <template v-slot:activator="{on}">
                      <v-list-item-subtitle v-on="on" v-html="dimensionsToString(markerXSolution)"></v-list-item-subtitle>
                    </template>
                    <span v-html="dimensionsToString(markerXSolution)"></span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-layout>
              <v-flex>
                <v-sheet v-if="$store.state.isMobile">
                  <v-container grid-list-sm fluid class="myContainer">
                    <div
                      v-for="(attachment,i) in markerXSolution.attachments"
                      :key="'p-'+i"
                      class="myColumn text-truncate"
                    >
                      <v-hover v-slot:default="{ hover }">
                        <div>
                          <v-card flat v-ripple tile>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on}">
                                <v-layout class="pa-2" @click="select(n.id)" v-on="on" column>
                                  <v-img
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    :src="attachment.content"
                                    aspect-ratio="1"
                                    width="142"
                                    class="white--text"
                                    @click="zoomPicture(attachment.content)"
                                  >
                                    <v-card-actions class="fill-height align-end gradient">
                                      <span
                                        class="text-truncate d-inline-block"
                                      >{{attachment.createdTs.substring(0,10)}}</span>
                                      <v-spacer></v-spacer>
                                      <v-icon
                                        color="success"
                                        v-if="attachment.approved"
                                      >check_circle</v-icon>
                                      <v-icon color="red" v-else>priority_high</v-icon>
                                    </v-card-actions>
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-layout>
                              </template>
                              <span>{{`${attachment.createdBy} (${attachment.createdTs.substring(0,10)})`}}</span>
                            </v-tooltip>
                          </v-card>
                        </div>
                      </v-hover>
                    </div>
                  </v-container>
                </v-sheet>
                <v-card flat v-else>
                  <v-container fluid>
                    <v-slide-y-transition group tag="v-row">
                      <v-col
                        v-for="(attachment, n) in markerXSolution.attachments"
                        :key="n"
                        class="d-flex child-flex"
                        :cols="2"
                      >
                        <v-card flat tile class="d-flex">
                          <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                              <v-layout column v-on="on">
                                <v-card flat tile>
                                  <v-img
                                    gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                                    :src="attachment.content"
                                    aspect-ratio="1"
                                    width="142"
                                    class="white--text"
                                    @click="zoomPicture(attachment.content)"
                                  >
                                    <v-card-actions class="fill-height align-end gradient">
                                      <span
                                        class="text-truncate d-inline-block"
                                      >{{attachment.createdTs.substring(0,10)}}</span>
                                      <v-spacer></v-spacer>
                                      <v-icon
                                        color="success"
                                        v-if="attachment.approved"
                                      >check_circle</v-icon>
                                      <v-icon color="red" v-else>priority_high</v-icon>
                                    </v-card-actions>
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-card>
                              </v-layout>
                            </template>
                            <span>{{`${attachment.createdBy} (${attachment.createdTs.substring(0,10)})`}}</span>
                          </v-tooltip>
                        </v-card>
                      </v-col>
                    </v-slide-y-transition>
                  </v-container>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }"></template>
      <v-card>
        <img v-bind:src="img" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uuid from "uuid";
import products from "@/components/Products";
import zoomPicture from "@/components/pages/Markers/ZoomPicture";

export default {
  props: {
    marker: Object,
    allAttributes: Object
  },
  components: {
    products,
    zoomPicture
  },
  data() {
    return {
      active: null,
      attributes: [],
      dialog: false,
      img: null,
      showDelete: false,
      isShowing: false,
      unusedAttributes: null,
      options: {
        duration: 300,
        easing: "easeInOutCubic",
        offset: 0
      },
      dimensionDialog: false,
      attributesDialog: false,
      emptyImage: require("@/assets/empty.png")
    };
  },
  computed: {
    markerXSolutions() {
      if (this.marker.markerXSolutions) {
        this.marker.markerXSolutions.forEach(mxs => {
          mxs.product = mxs.solution.image;
          try {
            mxs.qrLogAttributeXMarkerXSolutions.sort((a, b) =>
              a.qrLogAttribute.index > b.qrLogAttribute.index
                ? 1
                : b.qrLogAttribute.index > a.qrLogAttribute.index
                ? -1
                : 0
            );
          } catch (error) {}
        });
      }
      return this.marker.markerXSolutions;
    }
  },
  methods: {
   attributesToString(mxs) {
      let text = "";
            
      mxs.qrLogAttributeXMarkerXSolutions.forEach(x => {
        if (
          this.allAttributes.some(f => f.id == x.qrLogAttributeId)
        ) {
          if (!x.value) {
            let attribute = this.allAttributes
              .filter(f => f.id == x.qrLogAttributeId)[0]
              .qrLogAttributeListValue.find(
                z => z.id == x.qrLogAttributeListValueId
              );
            if (attribute) {
              text += `<small class="subtitle-2">${
                this.allAttributes.filter(
                  f => f.id == x.qrLogAttributeId
                )[0].code
              }</small>: ${attribute.description}, `;
            }
          } else {
            text += `${
              this.allAttributes.filter(
                f => f.id == x.qrLogAttributeId
              )[0].code
            }: ${x.value}, `;
          }
        }
      });
      // this.changeImage();
      return text;
    },
    dimensionsToString(mxs) {
      let html = "";
      if (mxs.amount != undefined) {
        html += `<small class="subtitle-2">${this.$t("amount")}</small>: ${
          mxs.amount
        },`;
      }
      if (mxs.unit != undefined) {
        html += `<small class="subtitle-2"> ${this.$t("unit")}
        </small>: ${mxs.unit},`;
      }
      if (mxs.width != undefined) {
        html += `<small class="subtitle-2"> ${this.$t("width")}</small>: ${
          mxs.width
        },`;
      }
      if (mxs.height != undefined) {
        html += `<small class="subtitle-2">${this.$t("height")}</small>: ${
          mxs.height
        },`;
      }
      if (mxs.length != undefined) {
        html += `<small class="subtitle-2">${this.$t("length")}</small>: ${
          mxs.length
        },`;
      }
      if (mxs.diameter != undefined) {
        html += `${this.$t("diameter")}: ${mxs.diameter}`;
      }
      return html;
    },
    selected(solutionId, selected) {
      this.$emit("selected", solutionId, selected);
    },
    setActive(mxs) {
      this.markerXSolutions.filter((x, i) => {
        if (x.id == mxs.id) this.active = i;
      });
      this.$forceUpdate();
    },
    zoomPicture(img) {
      this.img = img;
      this.dialog = true;
    },
    created() {
      // });
    }
    // watch: {
    //   markerXSolutions(n, o) {
    //     if (o.length > 0 && n.length == 0 && this.$store.state.hasChanges) {
    //       this.$store.state.hasChanges = false;
    //     }
    //   }
    // }
  }
};
</script>


<style scoped>
.v-expansion-panel-content {
  display: block;
}
.v-toolbar__content {
  padding-left: 0 !important;
}
.gradient {
  background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.5));
}
.myContainer {
  white-space: nowrap;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  overflow-y: scroll;
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
.myColumn {
  margin: 20px;
  flex: 1 1 auto;
  /* min-width: 300px; */
  min-width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/QR/Solutions.vue